import "@babel/polyfill";

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import configureStore from './store/configureStore';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/roboto.css';
import './assets/css/style.css';
import App from './App';

// Create browser history to use in the Redux store
const baseUrl = document.getElementById('baseRelativePath').getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const { store, persistor } = configureStore(history, initialState);
//const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </PersistGate>
    </Provider>,
    rootElement);


if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register(`${baseUrl}service-worker.js`, { scope: baseUrl }).then(registration => {
            console.log('SW registered');
        }).catch(registrationError => {
            console.log('SW registration failed: ', registrationError);
        });
    });
}
